import { GenericComponentWrapper } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/components/GenericComponentWrapper';
import { debounce } from 'lodash';
import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { LiabilitiesFiltersProps } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';
import { DateTimeRange, RangeType } from 'src/components/DatetimeRangeInput/DateTimeRange';

type DateRangeFilterPropsType = Pick<LiabilitiesFiltersProps, 'onChange'> & {
    range: RangeType;
};

export const DateRangeFilter = observer(
    'DateRangeFilter',
    ({ onChange, range }: DateRangeFilterPropsType): JSX.Element => {
        const { startDate, endDate } = range;
        const value = { startDate, endDate };

        return (
            <div className='col-4'>
                <GenericComponentWrapper
                    value={value}
                    name='range'
                >
                    <DateTimeRange
                        value={value}
                        onChange={debounce((range): void => onChange('range', range), 300)}
                    />
                </GenericComponentWrapper>
            </div>
        );
    }
);
